import styles from './ErrorGridItem.module.css';

export default function ErrorGridItem() {
  return (
    <div className={styles.Container}>
      <p>Oops.. Something went wrong displaying this animation</p>
    </div>
  );
}
